// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5592":"269215a52e94ddf1","7998":"87f1a05049fc369e"}[chunkId] + ".css";
};